var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"x-carousel",on:{"mouseleave":_vm.hoveroutListener,"mouseenter":_vm.hoverinListener}},[_c('div',{staticClass:"x-carousel-window"},[_c('div',{staticClass:"x-carousel-wrapper",class:( _obj = {}, _obj[_vm.card] = _vm.card, _obj )},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }